import type { PropsWithChildren } from 'react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { getCodesignTheme } from './create-codesign-theme'
import type { CodesignThemeName } from './presets'

export type CodesignThemeProviderProps = PropsWithChildren<{
  theme?: CodesignThemeName
}>

export function CodesignThemeProvider({ children, theme = 'earth' }: CodesignThemeProviderProps) {
  return (
    <ThemeProvider theme={getCodesignTheme(theme)}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
